import {
  EntityIconBase,
  type EntityIconAppearance,
  type EntityIconDensity,
} from './entity-icon-base';
import { BotIcon } from '@terra/ui-icons';

type IconAiEndpointProps = {
  appearance?: EntityIconAppearance;
  density?: EntityIconDensity;
};

export function IconAiEndpoint({ appearance, density }: IconAiEndpointProps) {
  return (
    <EntityIconBase
      icon={BotIcon}
      bg="violet.3"
      color="violet.9"
      borderColor="violet.6"
      appearance={appearance}
      density={density}
    />
  );
}
